import { gql } from "@apollo/client";
import CommonFragments from "features/common/fragments";
import Fragments from "./fragments";

export const BULK_PRINTING_OFFERS = gql`
  query pagedBulkPrintingOffers($pager: PagerInput, $filters: BulkPrintingOfferFilterInput) {
    pagedBulkPrintingOffers(pager: $pager, filters: $filters) {
      pagination(pager: $pager, filters: $filters) {
        ...pagination
      }
      values {
        ...bulkPrintingOffer
      }
    }
  }
  ${CommonFragments.pagination}
  ${Fragments.bulkPrintingOffer}
`;

export const BULK_DOCUMENT_TEMPLATES = gql`
  query bulkDocumentTemplates {
    bulkDocumentTemplates {
      documentTemplateId
      templateName
    }
  }
`;
